exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.line_b_black {\n  border-bottom: 1px solid #99a9bf;\n  background-color: #fff;\n}\n.nav {\n  height: 3rem;\n}\n.el-row {\n  padding: 5px;\n}\n.el-table__body, .el-table__footer, .el-table__header {\n    table-layout: auto;\n}\n.el-table th{/*表头加背景色*/\n    background:#F5F5F5 !important;\n    font-size:15px;\n}\n.ibox-content{\n    padding: 15px 20px 20px 20px;\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9d1a0fc4","scoped":false,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0&bustCache!./src/components/childmgr/childsmgr.vue
// module id = FPFn
// module chunks = 4